class $6a51d9de9bd339b8$var$ImperialView {
    #inputContainer = document.querySelector(".input__container");
    #formRadio = document.querySelector(".form__radio");
    #getHTML() {
        const html = `
        <form action="#" class="form__imperial" id="imperial__form">
          <div class="form__imperial-height">
            <label class="input__label" for="foot">Height</label>
            <input type="text" class="input__type" id="foot" name='foot' placeholder="0" />
            <div class="foot__container"><span class="ft">ft</span></div>
          </div>

          <div class="form__imperial-height">
            <label class="input__label-invisible" for="inch">Inch</label>
            <input type="text" class="input__type"  id="inch" name='inch' placeholder="0" />
            <div class="inch__container"><span class="in">in</span></div>
          </div>

          <div class="form__imperial-height">
            <label class="input__label" for="stone">Weight</label>
            <input type="text" class="input__type"  id="stone" name='stone' placeholder="0" />
            <div class="stone__container"><span class="st">st</span></div>
          </div>
          <div class="form__imperial-height">
            <label class="input__label-invisible"  for="pounds">Pounds</label>
            <input
              type="text"
              class="input__type"
              id="pounds"
              name='pounds'
              placeholder="0"
            />
            <div class="pounds__container"><span class="lbs">lbs</span></div>
          </div>
          <input class="input__btn" type="submit" />
      </form>`;
        return html;
    }
    render() {
        const viewHTML = this.#getHTML();
        this.#inputContainer.insertAdjacentHTML("beforeend", viewHTML);
        return this;
    }
    handleSubmit(handler) {
        this.#inputContainer.addEventListener("submit", handler);
    }
    clearContent() {
        this.#inputContainer.innerHTML = "";
        return this;
    }
    handleCheck(handler) {
        this.#formRadio.addEventListener("click", handler);
    }
}
var $6a51d9de9bd339b8$export$2e2bcd8739ae039 = new $6a51d9de9bd339b8$var$ImperialView();


class $11ea23320726a396$var$MetricView {
    #inputContainer = document.querySelector(".input__container");
    #formRadio = document.querySelector(".form__radio");
    #getHTML() {
        const html = `
      <form action="#" class="form__metric" id="metric__form">
          <div class="form__metric-height" >
            <label class="input__label" for="height">Height</label>
            <input
              type="text"
              class="input__type"
              id="height"
              name="height"
              placeholder="0"
              required
            />
            <div class="cm__container"><span class="cm">cm</span></div>
          </div>
          <div class="form__metric-weight">
            <label class="input__label" for="weight">Weight</label>
            <input
              type="text"
              class="input__type"
              id="weight"
              name="weight"
              placeholder="0"
              required
            />
            <div class="kg__container"><span class="kg">kg</span></div>
          </div>
          <input class="input__btn" type="submit" />
      </form>
        `;
        return html;
    }
    render() {
        const viewHTML = this.#getHTML();
        this.#inputContainer.insertAdjacentHTML("beforeend", viewHTML);
        return this;
    }
    handleSubmit(handler) {
        this.#inputContainer.addEventListener("submit", handler);
    }
    handleCheck(handler) {
        this.#formRadio.addEventListener("click", handler);
    }
    clearContent() {
        this.#inputContainer.innerHTML = "";
        return this;
    }
}
var $11ea23320726a396$export$2e2bcd8739ae039 = new $11ea23320726a396$var$MetricView();


class $fcd1a4d396d3ca2a$var$ResultsView {
    #parentElement = document.querySelector(".result__box");
    /**
   *
   * @param {Number} bmiResult
   * @param {Object} idealWeight
   * @returns this
   */ render(bmiResult, idealWeight) {
        const viewHTML = this.#getResultHTML(bmiResult, idealWeight);
        this.#parentElement.insertAdjacentHTML("beforeend", viewHTML);
        return this;
    }
    renderError(errorMessage) {
        const errorHTML = this.#getErrorHMTL(errorMessage);
        this.#parentElement.insertAdjacentHTML("beforeend", errorHTML);
        return this;
    }
    clearContent() {
        this.#parentElement.innerHTML = "";
        return this;
    }
    /**
   *
   * @param {Number} bmiResult
   * @param {Object} idealWeight
   * @returns Dynamic HMTL String
   */ #getResultHTML(bmiResult, idealWeight) {
        const html = `
        <div class="display__box">
            <div class="display__box-result">
              <p class="result__tip">Your BMI is...</p>
              <p class="bmi__result">${bmiResult}</p>
            </div>
            <div class="display__box-recommendation">
              <p class="bmi__recommendation">
                Your BMI suggest you have a healthy weight. Your ideal weight is
                between
              </p>
              <span class="min-bmi">${idealWeight.minLimitWeight}${idealWeight.isMetric ? "kgs" : "lbs"}</span>
              <span class="dash-separator">-</span>
              <span class="max-bmi">${idealWeight.maxLimitWeight}${idealWeight.isMetric ? "kgs" : "lbs"}</span>
            </div>
        </div>
      `;
        return html;
    }
    #getErrorHMTL(errorMessage) {
        const html = `
       <div class="error__box children_margin-bottom">
          <p class="error__box-subheading">Error! \u{1F623}</p>
          <p class="error__box-message">
          ${errorMessage}
          </p>
        </div>

    `;
        return html;
    }
}
var $fcd1a4d396d3ca2a$export$2e2bcd8739ae039 = new $fcd1a4d396d3ca2a$var$ResultsView();


/**
 *
 * @param {Object} param0 A JavaScript Object
 * @returns Number
 */ const $278b34025398d038$export$24c4383f3723bad9 = function({ weight: weight, height: height }) {
    if (weight === 0 || height === 0) throw new Error("Neither height nor weight can be 0");
    if (isNaN(weight) || isNaN(height)) throw new Error("Height & weight must both be numbers and not letters");
    if (weight < 0 || height < 0) throw new Error("Height or weight cannot be negative numbers");
    if (weight > 200 || height > 300) throw new Error("Neither height nor weight can be extreme numbers");
    return weight / (height / 100) ** 2;
};
const $278b34025398d038$export$a35ac294932fde9d = function({ foot: foot, inch: inch, stone: stone, pounds: pounds }) {
    if (isNaN(foot) || isNaN(inch) || isNaN(stone) || isNaN(pounds)) throw new Error("All inputs must be numbers and not letters");
    if (foot <= 0 || stone <= 0 || pounds <= 0) throw new Error("Neither foot, stone nor pounds can be 0 or less than 0 ");
    if (inch < 0) throw new Error("Inch cannot be less than 0");
    if (pounds > 1000 || stone > 1000 || foot > 100 || inch > 11) throw new Error("Neither input can be extreme numbers");
    const weightInPounds = stone * 14 + pounds;
    const heightInInches = foot * 12 + inch;
    if (weightInPounds === 0 || weightInPounds < 50 && heightInInches > 80) return;
    return weightInPounds / heightInInches ** 2 * 703;
};
const $278b34025398d038$export$67f0c3dfc6df813b = function({ foot: foot, inch: inch }) {
    if (foot <= 0 || inch < 0) return;
    if (foot > 100 || inch > 11) return;
    return foot * 12 + inch;
};
const $278b34025398d038$export$55026e2c862bf62e = function({ height: height }) {
    if (height === 0 || height > 300 || height < 0 || false) return;
    const minWeight = 18.5 * (height / 100) ** 2;
    const maxWeight = 24.9 * (height / 100) ** 2;
    const metricIdealWeight = {
        minLimitWeight: minWeight.toFixed(1),
        maxLimitWeight: maxWeight.toFixed(1),
        isMetric: true
    };
    return metricIdealWeight;
};
const $278b34025398d038$export$6e741d251f62ee4a = function(height) {
    if (height <= 0 || false) return;
    const minWeight = 18.5 * height ** 2 / 703;
    const maxWeight = 24.9 * height ** 2 / 703;
    const imperialIdealWeight = {
        minLimitWeight: minWeight.toFixed(1),
        maxLimitWeight: maxWeight.toFixed(1),
        isImperial: true
    };
    return imperialIdealWeight;
};


const $dad545c909cfec2d$var$init = ()=>{
    window.addEventListener("load", function() {
        (0, $11ea23320726a396$export$2e2bcd8739ae039).render();
    });
};
const $dad545c909cfec2d$var$controlMetricView = (event)=>{
    const inputContainer = event.target.closest(".form__radio").nextElementSibling;
    if (event.target.id === "metric" && inputContainer.firstElementChild.id === "imperial__form") {
        (0, $6a51d9de9bd339b8$export$2e2bcd8739ae039).clearContent();
        (0, $11ea23320726a396$export$2e2bcd8739ae039).render();
    } else return;
};
const $dad545c909cfec2d$var$controlImperialView = (event)=>{
    const inputContainer = event.target.closest(".form__radio").nextElementSibling;
    if (event.target.id === "imperial" && inputContainer.firstElementChild.id === "metric__form") {
        (0, $11ea23320726a396$export$2e2bcd8739ae039).clearContent();
        (0, $6a51d9de9bd339b8$export$2e2bcd8739ae039).render();
    } else return;
};
const $dad545c909cfec2d$var$getMetricBMI = (formData)=>{
    try {
        const bmi = (0, $278b34025398d038$export$24c4383f3723bad9)(formData);
        return bmi;
    } catch (error) {
        throw new Error(error.message);
    }
};
const $dad545c909cfec2d$var$getImperialBMI = (formData)=>{
    try {
        const bmi = (0, $278b34025398d038$export$a35ac294932fde9d)(formData);
        return bmi;
    } catch (error) {
        throw new Error(error.message);
    }
};
const $dad545c909cfec2d$var$controlMetricSubmit = (event)=>{
    try {
        if (event.target.tagName.toLowerCase() === "form" && event.target.id === "metric__form") {
            event.preventDefault();
            const data = new FormData(event.target);
            let metricFormData = {};
            data.forEach((value, key)=>{
                metricFormData[key] = +value;
            });
            event.target.children[0].firstElementChild.nextElementSibling.value = "";
            event.target.children[1].firstElementChild.nextElementSibling.value = "";
            (0, $fcd1a4d396d3ca2a$export$2e2bcd8739ae039).clearContent();
            const idealMetricWeight = (0, $278b34025398d038$export$55026e2c862bf62e)(metricFormData);
            const bmiResult = $dad545c909cfec2d$var$getMetricBMI(metricFormData).toFixed(1);
            (0, $fcd1a4d396d3ca2a$export$2e2bcd8739ae039).render(bmiResult, idealMetricWeight);
        } else return;
    } catch (error) {
        (0, $fcd1a4d396d3ca2a$export$2e2bcd8739ae039).renderError(error.message);
    }
};
const $dad545c909cfec2d$var$controlImperialSubmit = (event)=>{
    try {
        if (event.target.tagName.toLowerCase() === "form" && event.target.id === "imperial__form") {
            event.preventDefault();
            const data = new FormData(event.target);
            let imperialFormData = {};
            data.forEach((value, key)=>{
                imperialFormData[key] = +value;
            });
            event.target.children[0].firstElementChild.nextElementSibling.value = "";
            event.target.children[1].firstElementChild.nextElementSibling.value = "";
            event.target.children[2].firstElementChild.nextElementSibling.value = "";
            event.target.children[3].firstElementChild.nextElementSibling.value = "";
            (0, $fcd1a4d396d3ca2a$export$2e2bcd8739ae039).clearContent();
            const bmiResult = $dad545c909cfec2d$var$getImperialBMI(imperialFormData).toFixed(1);
            const height = (0, $278b34025398d038$export$67f0c3dfc6df813b)(imperialFormData);
            const idealImperialWeight = (0, $278b34025398d038$export$6e741d251f62ee4a)(height);
            // resultview.clearContent();
            (0, $fcd1a4d396d3ca2a$export$2e2bcd8739ae039).render(bmiResult, idealImperialWeight);
        } else return;
    } catch (error) {
        (0, $fcd1a4d396d3ca2a$export$2e2bcd8739ae039).renderError(error.message);
    }
};
$dad545c909cfec2d$var$init();
(0, $11ea23320726a396$export$2e2bcd8739ae039).handleCheck($dad545c909cfec2d$var$controlMetricView);
(0, $6a51d9de9bd339b8$export$2e2bcd8739ae039).handleCheck($dad545c909cfec2d$var$controlImperialView);
(0, $11ea23320726a396$export$2e2bcd8739ae039).handleSubmit($dad545c909cfec2d$var$controlMetricSubmit);
(0, $6a51d9de9bd339b8$export$2e2bcd8739ae039).handleSubmit($dad545c909cfec2d$var$controlImperialSubmit);


//# sourceMappingURL=index.c4f4d862.js.map
